query tipoAgenciaPorteSelect($where: EnumItemDTOFilterInput) {
    data: tiposAgenciaPortes(where: $where)  {
        label
        value
    }
}